var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.mainLoading,
          expression: "mainLoading",
        },
      ],
      staticClass: "wx-voice-div",
      on: {
        click: function ($event) {
          _vm.outTime ? "" : _vm.playVoice(_vm.objData)
        },
      },
    },
    [
      !_vm.outTime
        ? _c(
            "i",
            {
              class:
                _vm.objData.amrPlaying !== true
                  ? "icon-yuyin"
                  : "icon-playing1",
            },
            [
              _vm.objData.amrDuration
                ? _c("span", { staticClass: "amr-duration" }, [
                    _vm._v(_vm._s(_vm.objData.amrDuration) + '"'),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm.outTime
        ? _c("i", { staticClass: "el-icon-time" }, [
            _c("span", { staticClass: "amr-duration" }, [
              _vm._v("该语音已过期"),
            ]),
          ])
        : _vm._e(),
      _vm.objData.repContent
        ? _c(
            "div",
            [
              _c("el-tag", { attrs: { type: "success", size: "mini" } }, [
                _vm._v("语音识别"),
              ]),
              _vm._v(_vm._s(_vm.objData.repContent)),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }